import { IGetValidPaymentMethodId } from '../types';

/**
 * This function check if the paymentMethodId is part of the paymentMethods array and return a valid one
 */
export const getValidPaymentMethodId = ({
  paymentMethodId,
  paymentMethods
}: IGetValidPaymentMethodId) => {
  // Check if the paymentId is part of the filtered list
  const validPaymentMethod = paymentMethods.find(method => {
    const accountIdentifier = method.accountIdentifier ?? method.fdAccountId ?? '';
    return accountIdentifier === paymentMethodId;
  });
  // If it's a valid payment method, return it. Otherwise, return the first payment method in the list or an empty string
  return (
    validPaymentMethod?.accountIdentifier ??
    validPaymentMethod?.fdAccountId ??
    paymentMethods[0]?.accountIdentifier ??
    paymentMethods[0]?.fdAccountId ??
    ''
  );
};
